"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FadeIn = void 0;
var react_1 = __importDefault(require("react"));
var use_is_visible_1 = require("./hooks/use-is-visible");
var get_from_position_1 = require("./logic/get-from-position");
var defaultProps = {
    delayInMilliseconds: 0,
    durationInMilliseconds: 1200,
};
var FadeIn = function (props) {
    var _a;
    var _b = __assign(__assign({}, defaultProps), props), from = _b.from, triggerOffset = _b.triggerOffset, positionOffset = _b.positionOffset, delayInMilliseconds = _b.delayInMilliseconds, durationInMilliseconds = _b.durationInMilliseconds;
    var _c = (0, use_is_visible_1.useIsVisible)({
        offset: triggerOffset,
    }), isVisible = _c[0], isVisibleRef = _c[1];
    var fromPosition = (0, get_from_position_1.getFromPosition)(from);
    return (react_1.default.createElement("div", { style: (_a = {
                position: 'relative'
            },
            _a[fromPosition] = isVisible ? 0 : positionOffset,
            _a.opacity = isVisible ? 1 : 0,
            _a.transition = "".concat(fromPosition, " ").concat(durationInMilliseconds, "ms, opacity ").concat(durationInMilliseconds, "ms"),
            _a.transitionDelay = "".concat(delayInMilliseconds, "ms"),
            _a), ref: isVisibleRef }, props.children));
};
exports.FadeIn = FadeIn;
